import findIndex from 'lodash/findIndex';

export const GET_WORKFLOWS = 'GET_WORKFLOWS';
export const GET_WORKFLOWS_START = `${GET_WORKFLOWS}_START`;
export const GET_WORKFLOWS_SUCCESS = `${GET_WORKFLOWS}_SUCCESS`;
export const GET_WORKFLOWS_FAIL = `${GET_WORKFLOWS}_FAIL`;
export const RESET_SEARCH_IN_WORKFLOWS = 'RESET_SEARCHING_IN_WORKFLOWS';

export const GET_EDITABLE_WORKFLOWS = 'GET_EDITABLE_WORKFLOWS';
export const GET_EDITABLE_WORKFLOWS_START = `${GET_EDITABLE_WORKFLOWS}_START`;
export const GET_EDITABLE_WORKFLOWS_SUCCESS = `${GET_EDITABLE_WORKFLOWS}_SUCCESS`;
export const GET_EDITABLE_WORKFLOWS_FAIL = `${GET_EDITABLE_WORKFLOWS}_FAIL`;

export const UPDATE_WORKFLOW = 'UPDATE_WORKFLOW';
export const UPDATE_WORKFLOW_START = `${UPDATE_WORKFLOW}_START`;
export const UPDATE_WORKFLOW_SUCCESS = `${UPDATE_WORKFLOW}_SUCCESS`;
export const UPDATE_WORKFLOW_FAIL = `${UPDATE_WORKFLOW}_FAIL`;

export const DELETE_WORKFLOW = 'DELETE_WORKFLOW';
export const DELETE_WORKFLOW_START = `${DELETE_WORKFLOW}_START`;
export const DELETE_WORKFLOW_SUCCESS = `${DELETE_WORKFLOW}_SUCCESS`;
export const DELETE_WORKFLOW_FAIL = `${DELETE_WORKFLOW}_FAIL`;

export const CREATE_WORKFLOW = 'CREATE_WORKFLOW';
export const CREATE_WORKFLOW_START = `${CREATE_WORKFLOW}_START`;
export const CREATE_WORKFLOW_SUCCESS = `${CREATE_WORKFLOW}_SUCCESS`;
export const CREATE_WORKFLOW_FAIL = `${CREATE_WORKFLOW}_FAIL`;

export const WORKFLOW_LIST_ITEM_UPDATE_POSITION =
  'WORKFLOW_LIST_ITEM_UPDATE_POSITION';

export function getEditableWorkflows({ uri, parameters }) {
  return {
    type: GET_EDITABLE_WORKFLOWS,
    meta: {
      xmApi: true,
      uri,
      method: 'get',
      params: {
        ...parameters,
      },
    },
  };
}

export function getWorkflows({ uri, parameters }) {
  return {
    type: GET_WORKFLOWS,
    meta: {
      xmApi: true,
      uri,
      method: 'get',
      params: {
        ...parameters,
      },
    },
  };
}

export function createCustomWorkflow(createWorkflowData) {
  return {
    type: CREATE_WORKFLOW,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/plans',
      method: 'post',
      params: {
        ...createWorkflowData,
        enabled: true,
      },
    },
  };
}

export function deleteWorkflow(id) {
  return {
    type: DELETE_WORKFLOW,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${id}`,
      method: 'del',
    },
  };
}

function updateWorkflow(id, updatedFields) {
  return {
    type: UPDATE_WORKFLOW,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/plans',
      method: 'post',
      params: {
        id,
        ...updatedFields,
      },
    },
  };
}

export function setAccessPermissions(id, { accessibleByAll, permitted }) {
  return updateWorkflow(id, {
    accessibleByAll,
    permitted,
  });
}

export function setFloodControl(id, floodControl) {
  return updateWorkflow(id, {
    floodControl,
  });
}

export function setLoggingLevel(id, loggingLevel) {
  return updateWorkflow(id, { loggingLevel });
}

export function setWorkflowEnabled(id, enabled) {
  return updateWorkflow(id, { enabled });
}

export function customizeWorkflow(id) {
  return updateWorkflow(id, {
    planType: 'PLAN',
  });
}

export function updateWorkflowNameDescription(id, name, description) {
  return updateWorkflow(id, {
    name,
    description,
  });
}

export function resetSearchInWorkflows() {
  return dispatch => {
    dispatch({
      type: RESET_SEARCH_IN_WORKFLOWS,
    });
  };
}

export function updateWorkflowItemPosition(workflowId, position) {
  return (dispatch, getState) => {
    const oldPosition = findIndex(getState().workflows.allWorkflows.list, [
      'id',
      workflowId,
    ]);

    dispatch({
      type: WORKFLOW_LIST_ITEM_UPDATE_POSITION,
      payload: {
        workflowId,
        position,
      },
    });
    return dispatch(
      updateWorkflow(workflowId, {
        position,
      }),
    ).catch(e => {
      dispatch({
        type: WORKFLOW_LIST_ITEM_UPDATE_POSITION,
        payload: {
          workflowId,
          position: oldPosition,
        },
      });

      throw e;
    });
  };
}

export function updateWorkflowLocally(workflow) {
  return {
    type: UPDATE_WORKFLOW_SUCCESS,
    payload: {
      ...workflow,
    },
  };
}
